<script lang="ts">
  import type { ChipKind } from '$lib/utils/format';

  const { label, kind = 'gray', dot = false }: { label: string; kind?: ChipKind; dot?: boolean } = $props();
</script>

<span class="chip chip-{kind}">
  {#if dot}<span class="dot"></span>{/if}
  {label}
</span>
